import { ModuleFE_EHROrderConfiguration } from './ModuleFE_EHROrderConfiguration.js';
export const ModulePackFE_EHROrderConfiguration = [ModuleFE_EHROrderConfiguration];
//# sourceMappingURL=module-pack.js.map